/** @module                 React */

import { useState }         from "react";

/** @module                 Apollo */

import { useMutation }      from "@apollo/client";

import { UPDATE_POST }      from "../../Mutations/Posts";

const 

/** 
 * 
 * @returns useUpdatePost hook for updating existing post
 * 
 */

useEditPost = () => { const 

    /** @hooks */

    [ loading,  setLoading  ] = useState ( false ),

    [ errors,   setErrors   ] = useState ( false ),

    [ success,  setSuccess  ] = useState ( false ),

    /** @mutations */

    [ UpdatePost ] = useMutation ( UPDATE_POST, {

        /** @event onComplete */

        onCompleted ( data ) {

            setSuccess ( true );

            setLoading ( false );

        },

        /** @event onError */

        onError ( err ) { setLoading ( false ); setErrors ( true ); }

    } ),

    /** 
     * 
     * @param { String } title
     * 
     * @param { String } content
     * 
     * @param { String } description
     * 
     * @param { Boolean } isPublished
     * 
     * @param { Boolean } tiremarketOnly
     * 
     * @param { String } language
     * 
     * @returns update post action
     * 
     */

    updatePost = ( id, title, content, image, description, isPublished, tiremarketOnly, language ) => {

        /** @validation */

        setErrors ( false ); setLoading ( true ); setSuccess ( false );

        if ( ! title || ! content || ! language ) {

            setErrors   ( true  );

            setLoading  ( false );

            return;

        };

        /** @mutation */

        UpdatePost ( { variables: {

            id,

            title,

            image: ( typeof image !== "object" ) ? undefined : image,

            content,

            description,

            isPublished,

            tiremarketOnly,

            language
    
        } } );

    }

    /** @returns */

    return { updatePost, loading, errors, success }

};

/** @exports useEditPost */

export default useEditPost;